'use strict';
angular.module('resCenterAppRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.classifiedresource.app.resource', {
                url: '/resource?acode&fcode&is_host_site&flag&media_id&hybase_id&param_data&medianame',
                views: {
                    'networksource@front.networksource.classifiedresource.app': {
                        templateUrl: './networkResource/classifiedResource/app/main_tpl.html',
                        controller: 'resCenAppMainCtrl',
                    },
                },
            })
            .state('front.networksource.classifiedresource.app.quickpreview', {
                url: '/quickpreview?acode&fcode&is_host_site&flag&media_id&hybase_id&param_data&guid',
                views: {
                    'networksource@front.networksource.classifiedresource.app': {
                        templateUrl: './networkResource/classifiedResource/app/quickPreview/main_tpl.html',
                        controller: 'appQuickPreviewCtrl',
                    },
                },
            });
    },
]);
